export enum ErrorActionTypes {
  DISPAY_ERROR = 'DISPLAY_ERROR',
  HIDE_ERROR = 'HIDE_ERROR',
  SET_DISPATCH_FOR_ERROR = 'SET_DISPATCH_FOR_ERROR',
}
